import {SubmitHandler} from "./submit-handler.js";

/**
 * ApiSubmitHandler is a subclass of SubmitHandler. It extends functionality to provide
 * custom behavior when handling form submissions or similar events.
 *
 * This class adds a default event listener that reacts to user interactions, such as
 * click events, on a given component.
 *
 * Methods:
 * - defaultListeners(component): Overrides the parent's defaultListeners method to include
 *   additional event listeners specific to this class.
 *
 * Dependencies:
 * - Relies on a parent class SubmitHandler to provide the base functionality for managing
 *   listeners and handling events.
 */
export class ApiSubmitHandler extends SubmitHandler {
    /**
     * Registers default event listeners for the given component.
     *
     * @param {Object} component - The component to which default listeners are attached.
     * @return {void} - Does not return a value.
     */
    defaultListeners(component) {
        super.defaultListeners(component);

        component.addEventListener("click", event => alert('click'));
    }
}
